import { render, staticRenderFns } from "./AsEmployeeTab.vue?vue&type=template&id=1fdaeab4&scoped=true"
import script from "./AsEmployeeTab.vue?vue&type=script&lang=js"
export * from "./AsEmployeeTab.vue?vue&type=script&lang=js"
import style0 from "./AsEmployeeTab.vue?vue&type=style&index=0&id=1fdaeab4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdaeab4",
  null
  
)

export default component.exports